export type Tomo = {
  number: number
  icon: 'stethoscope' | 'sun' | 'beef' | 'moon' | 'apple' | 'cart'
  title: string
  paragraphs: string[]
  closing: string
}

export const tomos: Tomo[] = [
  {
    number: 1,
    icon: 'stethoscope',
    title: 'Fundamentos: entender para no tenerle más miedo a la comida',
    paragraphs: [
      'Antes de cocinar, necesitás entender. Qué le pasa a tu cuerpo con cada alimento. Cómo los carbohidratos, proteínas y grasas impactan el azúcar en sangre — explicado en humano, sin tecnicismos.',
      'Qué alimentos suman, cuáles restan y por qué. Y la base de todo el sistema: el Método de Sustitución Criolla Inteligente, la herramienta que te permite adaptar cualquier receta argentina sin perder el sabor.',
    ],
    closing: 'Cuando terminés este tomo, la comida deja de ser una amenaza. Se convierte en una herramienta.',
  },
  {
    number: 2,
    icon: 'sun',
    title: 'Desayunos rioplatenses sin culpa',
    paragraphs: [
      'El desayuno argentino tiene un problema: medialunas, facturas, pan blanco, mate con azúcar. Todo lo que “no podés comer”. O eso te dijeron.',
      'Este tomo te muestra cómo tener el desayuno que querés — adaptado: medialunas integrales que no disparan la glucosa, tostadas con palta en la combinación correcta, mate sin azúcar añadida que sigue siendo mate, y menús semanales para no improvisar ninguna mañana.',
    ],
    closing: 'Porque el día empieza bien cuando el desayuno está resuelto.',
  },
  {
    number: 3,
    icon: 'beef',
    title: 'Almuerzos y el asado inteligente',
    paragraphs: [
      'Este es el tomo que más le importa a los argentinos. Y con razón. El asado no se elimina: se adapta.',
      'Aprendés exactamente qué cortes elegir, cómo prepararlos, con qué acompañarlos y en qué cantidad servirlos para que el asado del domingo siga siendo el asado del domingo — sin el pico de glucosa del lunes. Además: empanadas integrales, milanesas al horno y menús de mediodía para toda la semana.',
    ],
    closing: 'Porque decirle adiós al asado no debería ser parte del diagnóstico.',
  },
  {
    number: 4,
    icon: 'moon',
    title: 'Cenas y postres sin remordimiento',
    paragraphs: [
      'Las cenas son el momento más difícil del día. Estás cansado/a, tenés poco tiempo y el cuerpo pide lo que siempre comiste.',
      'Este tomo resuelve exactamente eso: carbonada adaptada, platos típicos reinterpretados, cenas de menos de 30 minutos y postres que parecen trampa — y no lo son. Flan sin azúcar que sabe a flan. Budín de pan integral donde no se nota la diferencia.',
    ],
    closing: 'Porque terminar el día rico y liviano no debería ser un privilegio.',
  },
  {
    number: 5,
    icon: 'apple',
    title: 'Snacks, entre comidas y el control real',
    paragraphs: [
      'Los momentos entre comidas son donde más se cae el control. Son las 4 de la tarde, tenés hambre, y lo más fácil es agarrar una galletita, un alfajor, lo que haya — y después lamentarlo.',
      'Este tomo resuelve ese momento: bocadillos que no elevan el azúcar en sangre, smoothies sin azúcar añadida para cualquier hora, y la guía de control de porciones más clara que vas a leer.',
    ],
    closing: 'Porque el problema no es tener hambre. Es no saber qué comer cuando el hambre aparece.',
  },
  {
    number: 6,
    icon: 'cart',
    title: 'Planificación, listas de compras y seguimiento',
    paragraphs: [
      'Un sistema que no se puede sostener no es un sistema. Este tomo convierte todo lo anterior en un hábito real.',
      'Listas de compras específicas por receta y por semana, plan semanal de comidas para no tomar ninguna decisión improvisada, y plantillas de seguimiento de comidas y glucosa para ver — con números reales — cómo mejorás.',
    ],
    closing: 'Cuando tenés el plan, no necesitás fuerza de voluntad. El sistema trabaja por vos.',
  },
]

export const tomoChecklist: string[] = [
  'Recetas listas para imprimir y usar hoy mismo',
  'Ingredientes 100% disponibles en supermercados argentinos',
  'El Método de Sustitución Criolla Inteligente aplicado en cada receta',
  'Menús semanales — sin improvisar ningún día',
  'Información nutricional clara, sin tecnicismos',
  'Listas de compras por semana',
  'Guía de porciones para comer bien y no pasar hambre',
  '100% adaptado a la cocina y cultura alimentaria argentina',
]
